<div class="item-container d-flex flex-column">
  <div class="item-header">
    <h6 class="text-center">
      Add Single User</h6>
    <div class="edit-icons" mat-dialog-close>
      <i class="material-icons">close</i>
    </div>
  </div>
  <div class="item-content flex-grow-1 w-100">
    <form [formGroup]="userForm" class="d-flex flex-column gap-3">
      <div class="d-flex flex-wrap mt-3 gap-3">
        <div class="m-w-200 ">
          <label for="firstName">First name</label>
          <div class="form-input">
            <input type="text" class="form-control" placeholder="First name" formControlName="firstName">
            <i class="fas fa-user material-icons"></i>
          </div>
          <mat-error *ngIf="!userForm.get('firstName')?.value  && userForm.get('firstName')?.touched">
            This field required </mat-error>
        </div>
        <div class="m-w-200 ">
          <label for="lastName">Last name</label>
          <div class="form-input">
            <input type="text" class="form-control" placeholder="Last name" formControlName="lastName">
            <i class="fas fa-user material-icons"></i>
          </div>
          <mat-error *ngIf="!userForm.get('lastName')?.value  && userForm.get('lastName')?.touched">
            This field required </mat-error>
        </div>
      </div>
      <div class="m-w-200 w-100">
        <label for="email">Email</label>
        <div class="form-input">
          <input type="text" class="form-control" placeholder="{{'abc@gmail.com' | translate}}" formControlName="email">
          <img src="assets/images/icons/website.png" class="img-fluid material-icons" alt="">
        </div>
        <mat-error *ngIf="!userForm.get('email')?.value  && userForm.get('email')?.touched">
          This field required </mat-error>
        <mat-error
          *ngIf="userForm.get('email')?.invalid && userForm.get('email')?.value && userForm.get('email')?.touched">
          A valid email is required.
        </mat-error>
      </div>
      <div class="d-flex flex-wrap gap-3">
        <div class="m-w-200 ">
          <label for="password">Password</label>
          <div class="form-input">
            <input type="{{isShowPassword ? 'text' : 'password'}}" class="form-control" placeholder="Enter password"
              formControlName="password">
            <img src="assets/images/icons/pwd.svg" class="img-fluid material-icons">
            <img src="assets/images/icons/eye.svg" *ngIf="isShowPassword" class="img-fluid  eye-icon pointer"
              (click)="toggleShowPassword('password')">
            <img src="assets/images/icons/eye_cancel.svg" *ngIf="!isShowPassword" class="img-fluid  eye-icon pointer"
              (click)="toggleShowPassword('password')">
          </div>

          <mat-error *ngIf="!userForm.get('password')?.value  && userForm.get('password')?.touched">
            This field required </mat-error>
            <mat-error *ngIf="userForm.get('password')?.hasError('minlength') && userForm.get('password')?.touched">
              Password must be at least 8 characters long.
            </mat-error>
          
        </div>
        <div class="m-w-200 ">
          <label for="confirmPassword">Confirm password</label>

          <div class="form-input">
            <input type="{{isShowCPassword ? 'text' : 'password'}}" class="form-control"
              placeholder="Enter confirm password" formControlName="confirmPassword">
            <img src="assets/images/icons/cpwd.svg" class="img-fluid material-icons">
            <img src="assets/images/icons/eye.svg" *ngIf="isShowCPassword" class="img-fluid  eye-icon pointer"
              (click)="toggleShowPassword('confirm_password')">
            <img src="assets/images/icons/eye_cancel.svg" *ngIf="!isShowCPassword" class="img-fluid  eye-icon pointer"
              (click)="toggleShowPassword('confirm_password')">
          </div>
          <mat-error
            *ngIf="userForm.hasError('mismatch') && userForm.get('confirmPassword')?.value && userForm.get('confirmPassword')?.touched">
            Passwords do not match.
          </mat-error>
          <mat-error *ngIf="!userForm.get('confirmPassword')?.value  && userForm.get('confirmPassword')?.touched">
            This field required </mat-error>
        </div>
      </div>
    </form>


    <div class="mt-3 d-flex flex-wrap gap-2">
      <!-- Select All Checkbox -->
      <mat-checkbox class="c-check-box" [(ngModel)]="isSelectedAll" (change)="toggleSelectAll()">
        <div class="text-wrap">Select All</div>
      </mat-checkbox>

      <!-- Individual Checkboxes -->
      <mat-checkbox class="c-check-box" *ngFor="let item of managerAccessListArray; let i = index"
        [(ngModel)]="selectedAccessKeys[i]">
        <div class="text-wrap">{{ item.access_value }}</div>
      </mat-checkbox>
    </div>

  </div>
  <div class="item-footer">
    <div class="d-flex align-items-center justify-content-center flex-wrap position-relative">
      <button type="button" style="min-width: 180px;" (click)="onClose()"
        class="btn btn-outline-primary mt-2 mt-lg-3 me-3">Cancel</button>
      <button mat-raised-button color="primary" (click)="onSubmit()" type="submit" style="min-width: 180px;"
        class="btn btn-primary mt-2 mt-lg-3 me-3">Submit</button>
    </div>
  </div>
</div>